import { BaseColumnSchemaPart, } from "@for-it/domain-lib";
import { EntitySchema } from "typeorm";
export const TenantStatus = {
    ACTIVE: "active",
    SUSPENDED: "suspended",
    DELETED: "deleted",
};
export const TenantEntity = new EntitySchema({
    name: "tenants",
    columns: {
        ...BaseColumnSchemaPart,
        subdomain: {
            type: "varchar",
            length: 63,
            unique: true,
        },
        customDomain: {
            type: "varchar",
            length: 255,
            nullable: true,
            unique: true,
        },
        organizationName: {
            type: "varchar",
            length: 255,
        },
        contactEmail: {
            type: "varchar",
            length: 255,
        },
        dbName: {
            type: "varchar",
            length: 63,
            unique: true,
        },
        status: {
            type: "varchar",
            length: 20,
            default: TenantStatus.ACTIVE,
        },
        subscriptionStatus: {
            type: "varchar",
            length: 50,
            nullable: true,
        },
        trialEndsAt: {
            type: "datetime",
            nullable: true,
        },
        plan: {
            type: "varchar",
            length: 50,
            nullable: true,
        },
    },
    indices: [
        { name: "idx_subdomain", columns: ["subdomain"] },
        { name: "idx_custom_domain", columns: ["customDomain"] },
        { name: "idx_status", columns: ["status"] },
    ],
});
export function sanitizeSubdomain(subdomain) {
    return subdomain
        .toLowerCase()
        .replace(/[^a-z0-9-]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")
        .slice(0, 63);
}
export function validateSubdomain(subdomain) {
    const sanitized = sanitizeSubdomain(subdomain);
    return (sanitized.length >= 3 &&
        sanitized.length <= 63 &&
        /^[a-z0-9][a-z0-9-]*[a-z0-9]$/.test(sanitized));
}
export function getTenantDbName(tenantId) {
    // Strip dashes from uuid so the name stays within MySQL's 64-char identifier limit
    // and is a valid MySQL database identifier.
    return `tenant_${tenantId.replace(/-/g, "")}`;
}
